import { createAsyncThunk } from '@reduxjs/toolkit';
import { activateAiLicence as activateAiLicenceService } from '../../services/activateAiLicence.service';
import { loadAdminAiLicences } from './loadAdminAiLicences.thunk';

/**
 * Activates a business's licence, then reloads the licence list so the row
 * shows its new state before the save is reported done.
 */
export const activateAiLicence = createAsyncThunk(
  'adminAi/activateAiLicence',
  async ({ businessId, businessName }, { dispatch, rejectWithValue }) => {
    try {
      await activateAiLicenceService({ businessId, businessName });
    } catch (error) {
      return rejectWithValue(
        error.message || 'Failed to activate the AI licence'
      );
    }
    await dispatch(loadAdminAiLicences());
    return { businessId };
  }
);
